import Axios from 'axios';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import { collectMyTeamMemberIds } from '../../../utils/teamMemberIds'; // 360度チームメンバーIDの収集（グループ全ユーザ取得の廃止）
// 簡易ログイン（メール未確認）セッションでは結果のダウンロードを行わせない
import {
  isTrialQuickSession,
  blockResultForQuickSession,
} from '../../../utils/trialGuard';
import React, { Fragment, useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Table, Spin, Button, message, Space, Modal } from 'antd';
import config from '../../Config/key';
// ページ外郭コンテナ（デザインシステム Ph.4: width:90% → max-width 1240px へ統一）
// StatusBadge（デザインシステム Ph.6 後続-4: ステータス列の素の色付き span → tone ベース pill へ統一）
import {
  PageContainer,
  StatusBadge,
  SURVEY_STATUS_TONE,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
  dateSorter,
} from '../../common';
import { surveyCode } from '../../Config/surveyCode';
import { surveyStatus } from '../../Config/surveyStatus';
import { BsBoxArrowUpRight } from 'react-icons/bs';
// import GuidePage from '../TakeSurveyPage/Sections/GuidePage';
const { confirm } = Modal;
let tUsers = [];
let selSurveySeasonId = '';

function MySurveyPage(props) {
  // console.log({ props });
  const { user } = props;
  const dispatch = useDispatch(); // ログアウト処理（簡易ログインセッションの結果ブロック時）で使用
  const [mySurvey, setMySurvey] = useState([]);
  const [selSeasonInfo, setSelSeasonInfo] = useState([]);
  const [groupInfo, setGroupInfo] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [tokenInfo, setTokenInfo] = useState();
  // const [questionInfo, setQuestionInfo] = useState([]);
  //const [myUser, setMyUser] = useState([]);
  // let user = useSelector((state) => state.user);
  // const history = useHistory();
  //if (!user.userData) return null;

  //console.log({ myUser });

  //yyyy/mm/dd hh:mm
  const ymdhms = (tdate) => {
    let date = new Date(tdate);
    //console.log({ date });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
      // date.getMilliseconds()
    );
  };
  //yyyy/mm/dd
  const ymd = (tdate) => {
    let date = new Date(tdate);
    // console.log({ tdate });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2)
      // date.getMilliseconds()
    );
  };
  const isPassed = (targetDate) => {
    const now = new Date();
    // 日付のみで比較（時刻を無視してJST 0時から公開されるようにする）
    return ymd(targetDate) <= ymd(now);
  };

  // サーベイ日程表示用（日付のみ）
  const formatSurveyDateOnly = (dateValue) => {
    if (!dateValue) return '-';

    // 既にフォーマット済みの場合
    if (typeof dateValue === 'string' && dateValue.includes('/')) {
      return dateValue.split(' ')[0]; // 時間部分削除
    }

    // ISO文字列から日付部分のみ抽出
    const dateStr = dateValue.split('T')[0];
    const [year, month, day] = dateStr.split('-');

    return `${year}/${month}/${day}`;
  };

  // トライアルユーザー判定（trial_campaign_key を持つユーザー）
  const isTrialUser = !!(user && user.userData && user.userData.trialCampaignKey);

  // UTC instant（Date|ISO）→ JST(UTC+9) の暦日 'YYYY/MM/DD'（表示用）
  // token_expire は「登録時刻 + N日」の実 timestamp のため、ブラウザの
  // ローカルTZに依存せず日本基準の日付を出すよう getTime()+9h → getUTC* で算出。
  const formatJstDateOnly = (dateValue) => {
    if (!dateValue) return '-';
    const jst = new Date(new Date(dateValue).getTime() + 9 * 60 * 60 * 1000);
    return (
      jst.getUTCFullYear() +
      '/' +
      ('0' + (jst.getUTCMonth() + 1)).slice(-2) +
      '/' +
      ('0' + jst.getUTCDate()).slice(-2)
    );
  };

  // UTC instant → JST 'YYYY-MM-DD'（大小比較用キー）
  const jstDateKey = (dateValue) => {
    const jst = new Date(new Date(dateValue).getTime() + 9 * 60 * 60 * 1000);
    return (
      jst.getUTCFullYear() +
      '-' +
      ('0' + (jst.getUTCMonth() + 1)).slice(-2) +
      '-' +
      ('0' + jst.getUTCDate()).slice(-2)
    );
  };

  // サーベイ回答日程の範囲内判定（日付のみで比較、両端を含む）
  const isInSurveyPeriod = (startDateStr, endDateStr) => {
    if (!startDateStr || !endDateStr) return false;

    // 日付部分のみ抽出
    const start = startDateStr.split('T')[0];
    const end = endDateStr.split('T')[0];

    // 現在の日付を取得（時間除外）
    const today = new Date();
    const todayStr =
      today.getFullYear() +
      '-' +
      ('0' + (today.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + today.getDate()).slice(-2);

    // 開始日当日から終了日当日まで有効
    return todayStr >= start && todayStr <= end;
  };

  const readDB = async () => {
    try {
      if (!user.userData) return null;
      // console.log(user.userData.isAuth);
      if (user.userData.isAuth) {
        message.loading({
          content: '読み込み中...',
          key: 'updateable',
          duration: 20,
        });
        const [surveyInfo, seasonInfo, tokenInfo, group] = await Promise.all([
          Axios.get('/api/survey/'),
          Axios.get(`/api/surveySeason/g/${user.userData.groupCode}`), //DBからシーズン情報取得
          Axios.get(`api/surveyToken/u/${user.userData._id}`),
          Axios.get(`/api/group/${user.userData.groupCode}`),
          // Axios.get(`api/relation360/u/${user.userData._id}`), //結果があるのは本人
        ]);
        //Promise.allがどきどきNginxで動作しない疑いがあり、下記のように修正
        // const surveyInfo = await Axios.get('/api/survey/');
        // console.log('1');
        // const seasonInfo = await Axios.get('/api/surveySeason/'); //DBからシーズン情報取得
        // console.log('2');
        // const tokenInfo = await Axios.get(
        //   `api/surveyToken/u/${user.userData._id}`
        // );
        // console.log('3');
        // const gUsers = await Axios.get(
        //   `${config.USER_SERVER}/group/${user.userData.groupCode}`
        // );
        // console.log('4');
        // const group = await Axios.get(`/api/group/${user.userData.groupCode}`);
        // console.log('5');
        //ここまで

        // 360度チーム進捗計算に必要なチームメンバーのみ取得
        // （旧: グループ全ユーザ取得。数千名グループで一覧表示遅延の主因だった。
        //   360度系サーベイが無いユーザーは対象0件のため照会自体を省略する）
        const teamIds = collectMyTeamMemberIds(
          [
            seasonInfo.data.surveySeason,
            group.data.group && group.data.group.survey_season,
          ],
          user.userData._id
        );
        if (teamIds.length > 0) {
          const teamRes = await Axios.post(
            `${config.USER_SERVER}/team-members`,
            { userIds: teamIds }
          );
          tUsers = teamRes.data.users;
        } else {
          tUsers = [];
        }

        // console.log(relation360.data.relation360);
        let surveyToken = tokenInfo.data.token.concat();
        let sortedToken = tokenInfo.data.token.concat().sort(function (a, b) {
          return a.updatedAt > b.updatedAt ? -1 : 1; //オブジェクトの昇順ソート
        });
        // console.log({ surveyToken });
        // console.log({ sortedToken });
        let surveySeason = seasonInfo.data.surveySeason;
        // console.log({ surveySeason });
        let survey = surveyInfo.data.survey;
        setGroupInfo(group.data.group);
        const gInfo = group.data.group;
        // let relationInfo = relation360.data.relation360;
        // console.log({ gUsers });

        // console.log(user.userData.groupCode);
        if (!surveyInfo.data.survey)
          throw new Error('サーベイ取得に失敗しました。');
        if (!surveyToken) throw new Error('トークン取得に失敗しました。');

        // 一時保存データの存在確認
        const tokenIds = surveyToken.map((token) => token._id);
        let tempAnswerStatus = {};
        try {
          const tempCheckResponse = await Axios.post(
            '/api/tempAnswer/checkMultiple',
            { tokenIds }
          );
          if (tempCheckResponse.data.success) {
            tempAnswerStatus = tempCheckResponse.data.tempAnswerStatus;
          }
        } catch (error) {
          console.log('一時保存データ確認エラー:', error);
        }

        // console.log({ surveyToken });
        await surveyToken.map(async (token) => {
          token.surveyName = surveyCode[token.survey_code];
          const ssi = surveySeason.find(
            (item) => item._id === token.survey_season_id
          );

          // 一時保存データがある場合は「一時保存中」に変更
          if (token.survey_status === 0 && tempAnswerStatus[token._id]) {
            token.survey_status = 1;
          }

          token.surveyStatusName = surveyStatus[token.survey_status];
          // if (token.question_set_id) {
          //   //設問セットがある場合は設問セット名も一緒に表記
          //   let survey = surveyInfo.data.survey.find(
          //     (item) => item._id === token.survey_id
          //   );
          //   // console.log({ surveyInfo });
          //   token.surveyName =
          //     surveyCode[token.survey_code] +
          //     '(' +
          //     survey.question_set.find(
          //       (item) => item._id === token.question_set_id
          //     ).set_name +
          //     ')';
          // }
          let surveyName = '';
          let tName = '';
          let relationInfo = [];
          let name360 = ''; // 診断表示名（シーズンの name_360）。360度診断/BSFS の表示名に使用
          //シーズンIDが存在するならシーズン名を表示
          if (token.survey_season_id) {
            selSurveySeasonId = token.survey_season_id;
            //全体シーズン情報からこのTokenのSurveySeasonIdと同じシーズン情報を１個格納
            let surveySeasonInfo = surveySeason.find(
              (item) => item._id === token.survey_season_id
            );
            // console.log({ surveySeasonInfo });
            // console.log(user.userData._id);
            token.active = surveySeasonInfo.active;
            surveyName = surveySeasonInfo.season_name;
            name360 = surveySeasonInfo.name_360; // 診断表示名（未設定なら後段でサーベイ種別名にフォールバック）
            tName = surveySeasonInfo.t_name;
            token.training_start_date = surveySeasonInfo.training_start_date;
            token.training_end_date = surveySeasonInfo.training_end_date;
            token.survey_start_date = surveySeasonInfo.survey_start_date;
            token.survey_end_date = surveySeasonInfo.survey_end_date;
            setSelSeasonInfo(surveySeasonInfo);
            //このTokenのSurveySeasonに含まれている360リレーション情報の中でログインユーザが本人になっているリレーション情報を格納
            // console.log({ token });

            if (token.survey_code === '40010') {
              if (token.relation === 1) {
                relationInfo = surveySeasonInfo.relation_360.find(
                  (item) => item.user_id === user.userData._id
                );

                //本人の場合
                //ログインユーザが本人の場合のみ情報がある
                token.relationInfo = relationInfo;
                token.output_360_type = surveySeasonInfo.output_360_type; //０：非公開、１：受験後公開、２：日付で公開
                token.output_360_date = surveySeasonInfo.output_360_date; //公開日：00:00時
                token.type_360 = surveySeasonInfo.question_set[0].type_360;

                token.test = 0;
                // let data = {};
                let data = makeTeam(relationInfo);
                // console.log({ data });

                // makeTeam(relationInfo)
                //   .then((item) => {
                //     console.log({ item });
                //     data = item;
                //     data.cnt += 1; //本人分の追加
                //     data.done = data.done + (token.survey_status === 5 ? 1 : 0);
                //     token.allStatus = data.cnt === data.done ? 1 : 0;
                //   })
                //   .catch((e) => {
                //     console.error(e);
                //   });
                // console.log({ data });
                data.cnt += 1; //本人分の追加
                data.done = data.done + (token.survey_status === 5 ? 1 : 0);
                token.allStatus = data.cnt === data.done ? 1 : 0;
                // token.allStatus = 0;
                // console.log(
                //   `data.cnt:${data.cnt}, data.done:${data.done}, token.allStatus:${token.allStatus}`
                // );
                // console.log(isPassed(surveySeasonInfo.output_360_date));
                let lastSeasonTokenInfo = sortedToken.find(
                  (tokenInfo) =>
                    tokenInfo.survey_status === 5 &&
                    tokenInfo.relation === 1 &&
                    tokenInfo.survey_code === '40010' &&
                    tokenInfo.survey_season_id != token.survey_season_id &&
                    ymd(tokenInfo.updatedAt) < ymd(token.updatedAt) &&
                    tokenInfo.question_set_id === token.question_set_id
                );
                let lastSeason = false;
                if (lastSeasonTokenInfo) {
                  const lastSurveySeason = gInfo.survey_season.find(
                    (item) => item._id === lastSeasonTokenInfo.survey_season_id
                  );
                  // console.log(lastSurveySeason);
                  lastSeason = isLastSeasonComplete(
                    user.userData,
                    lastSurveySeason
                  );
                }
                token.lastSeason = lastSeason;
                if (lastSeason) {
                  token.lastSeasonTokenInfo = lastSeasonTokenInfo;
                  token.lastSurveySeason = gInfo.survey_season.find(
                    (item) => item._id === lastSeasonTokenInfo.survey_season_id
                  );
                }
              } //else {
              //本人ではない場合
              // for (let i = 0; i < surveySeasonInfo.relation_360.length; i++) {
              //   const element = surveySeasonInfo.relation_360[i];
              //   for (let j = 0; j < element.boss.length; j++) {
              //     const boss_id = element.boss[j];
              //     if (user.userData._id === boss_id) {
              //       token.hero_id = element.user_id;
              //     }
              //   }
              //   for (let k = 0; k < element.partner.length; k++) {
              //     const partner_id = element.partner[k];
              //     if (user.userData._id === partner_id) {
              //       token.hero_id = element.user_id;
              //     }
              //   }
              // }
              // let selUser = tUsers.find((item) => item._id === token.hero_id);
              // token.hero_name = selUser.lastname + ' ' + selUser.name;
              // console.log({ token });
              // }
            } else if (
              token.survey_code === '90101' ||
              token.survey_code === '90502' ||
              token.survey_code === '90501'
            ) {
              token.coursePartView = surveySeasonInfo.course_part_view;
            } else if (token.survey_code === '90301') {
              token.coursePartView = surveySeasonInfo.course_part_view;
              token.e3_option = surveySeasonInfo.e3_option;
            } else if (token.survey_code === '30010') {
              token.e3_option = surveySeasonInfo.e3_option;
              if (token.e3_option === 1 || token.e3_option === 2) {
                token.output_360_type = surveySeasonInfo.output_360_type ?? 1; //過去データ互換：未設定は受検直後公開
                token.output_360_date = surveySeasonInfo.output_360_date;
              }
            } else if (token.survey_code === '60020') {
              // console.log({ token });
              // console.log({ surveySeasonInfo });
              token.type_360 = surveySeasonInfo.question_set[0].type_360;
              if (token.relation === 1) {
                relationInfo = surveySeasonInfo.relation_360.find(
                  (item) => item.user_id === user.userData._id
                );

                //本人の場合
                //ログインユーザが本人の場合のみ情報がある
                token.relationInfo = relationInfo;
                token.output_360_type = surveySeasonInfo.output_360_type; //０：非公開、１：受験後公開、２：日付で公開
                token.output_360_date = surveySeasonInfo.output_360_date; //公開日：00:00時
                token.test = 0;
                // let data = {};
                let data = makeTeam(relationInfo);
                data.cnt += 1; //本人分の追加
                data.done = data.done + (token.survey_status === 5 ? 1 : 0);
                token.allStatus = data.cnt === data.done ? 1 : 0;
              }
            } else if (
              token.survey_code === '50020' ||
              token.survey_code === '50030' ||
              token.survey_code === '50040' ||
              token.survey_code === '10010' ||
              token.survey_code === '50010'
            ) {
              token.output_360_type = surveySeasonInfo.output_360_type ?? 1; //０：非公開、１：受験後公開、２：日付で公開（過去データ互換：未設定は受験後公開）
              token.output_360_date = surveySeasonInfo.output_360_date; //公開日：00:00時
            }
          } else {
            surveyName = surveyCode[token.survey_code];
          }
          //Question Set Idが存在するならQuestionSet名を表示
          //360度診断/BSFS（40010・60020）は設問セット名（TXXX）を表示しないため除外する
          if (
            token.question_set_id &&
            token.survey_code !== '20210' &&
            token.survey_code !== '40010' &&
            token.survey_code !== '60020'
          ) {
            let surveyInfo = survey.find(
              (item) => item._id === token.survey_id
            );
            surveyName =
              surveyName +
              ' : ' +
              surveyInfo.question_set.find(
                (item) => item._id === token.question_set_id
              ).set_name;
          }
          if (token.survey_code === '40010' || token.survey_code === '60020') {
            // マイ・サーベイの360度診断/BSFS 表示名を統一：
            //   [本人向け/協力者向け]{診断表示名}（対象者：氏名 様）
            // ・診断表示名 … シーズンの name_360（未設定時はサーベイ種別名にフォールバック）
            // ・本人（relation===1）… 対象者はログインユーザー自身
            // ・協力者（relation!==1）… 対象者はトークンの hero_name
            // ・設問セット名（TXXX）は表示しない
            const displayName360 = name360 || surveyCode[token.survey_code];
            const relationLabel =
              token.relation === 1 ? '[本人向け]' : '[協力者向け]';
            const targetName =
              token.relation === 1
                ? `${user.userData.lastname} ${user.userData.name}`
                : token.hero_name || '';
            surveyName = `${relationLabel}${displayName360}（対象者：${targetName} 様）`;
          }
          token.surveyName = surveyName;
          token.tName = tName;
          // if (relationInfo) {
          //   console.log({ relationInfo });
          //   //   //ログインユーザが本人の場合のみ情報がある
          //   //   token.relationInfo = relationInfo;
          //   let data = makeTeam(relationInfo);
          //   data.cnt += 1; //本人分の追加
          //   data.done = data.done + (token.survey_status === 5 ? 1 : 0);
          //   token.totalStatus = data.cnt === data.done ? true : false;
          //   //   // console.log({ data });
          // }
          return token;
        });
        setMySurvey(
          surveyToken.filter((item) => {
            if (!item.active) return false;
            // 実施済み(5)はシーズン範囲に関わらず常に表示（結果確認用）
            if (item.survey_status === 5) return true;
            // トライアルユーザー: シーズン期間ではなくトークンの有効期限（token_expire, JST）で制御
            if (isTrialUser) {
              if (!item.token_expire) return false;
              // 今日(JST) ≤ 有効期限(JST) … 有効期限当日まで表示（inclusive）
              return jstDateKey(new Date()) <= jstDateKey(item.token_expire);
            }
            // それ以外: SurveySeasonの回答日程範囲内のみ表示
            if (!item.survey_season_id) return false;
            const ssi = surveySeason.find(
              (s) => s._id === item.survey_season_id
            );
            if (!ssi) return false;
            return isInSurveyPeriod(
              ssi.survey_start_date,
              ssi.survey_end_date
            );
          })
        );
        // setMySurvey(surveyToken);
        message.success({
          content: '読み込み完了！',
          key: 'updateable',
          duration: 2,
        });
        // console.log({ surveyToken });
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ mySurvey });
  }, [user]);

  const isLastSeasonComplete = (user, lastSurveySeason) => {
    let doneCnt = 0;
    let totalCnt = 0;
    // let heroCnt = 1;
    let bossCnt = 0;
    let partnerCnt = 0;
    const team = lastSurveySeason.relation_360.find(
      (item) => item.user_id === user._id
    );

    let seasonTokenInfo = {};
    // console.log({ team });
    for (let i = 0; i < team.boss.length; i++) {
      const bossId = team.boss[i];
      const bossInfo = tUsers.find((item) => item._id === bossId);
      if (bossInfo.survey_token.length === 0) {
        bossInfo.status = false;
        seasonTokenInfo = {};
      } else {
        seasonTokenInfo = bossInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === lastSurveySeason._id &&
            tokenInfo.hero_id === user._id
        );
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          doneCnt++;
          totalCnt++;
          bossCnt++;
        } else {
          totalCnt++;
        }
      }
    }
    for (let i = 0; i < team.partner.length; i++) {
      const partnerId = team.partner[i];
      const partnerInfo = tUsers.find((item) => item._id === partnerId);
      if (partnerInfo.survey_token.length === 0) {
        partnerInfo.status = false;
        seasonTokenInfo = {};
      } else {
        seasonTokenInfo = partnerInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === lastSurveySeason._id &&
            tokenInfo.hero_id === user._id
        );
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          doneCnt++;
          totalCnt++;
          partnerCnt++;
        } else {
          totalCnt++;
        }
      }
    }
    // console.log({ doneCnt });
    // console.log({ totalCnt });
    return totalCnt === doneCnt && totalCnt > 0 ? true : false;
  };

  const makeTeam = (team) => {
    // const team = selSurveySeason.relation_360.find(
    //   (item) => item.user_id === user._id
    // );
    // if (tUsers.length === 0) {
    //   const gUsers = await Axios.get(
    //     `${config.USER_SERVER}/group/${user.userData.groupCode}`
    //   );
    //   tUsers = gUsers.data.users;
    // }
    let data = { cnt: 0, done: 0 };
    // console.log({ team });
    team.boss.map((bossId) => {
      const bossInfo = tUsers.find((item) => item._id === bossId);
      // console.log({ bossInfo });
      if (bossInfo.survey_token.length === 0) {
        bossInfo.status = false;
      } else {
        let seasonTokenInfo = bossInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === team.survey_season_id &&
            tokenInfo.relation === 2 &&
            tokenInfo.hero_id === team.user_id
        );
        data.cnt += 1;
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          data.done += 1;
        }
      }
      return;
    });

    team.partner.map((partnerId) => {
      const partnerInfo = tUsers.find((item) => item._id === partnerId);
      // console.log({ partnerInfo });
      if (partnerInfo.survey_token.length === 0) {
        partnerInfo.status = false;
      } else {
        let seasonTokenInfo = partnerInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === team.survey_season_id &&
            tokenInfo.relation === 3 &&
            tokenInfo.hero_id === team.user_id
        );
        data.cnt += 1;
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          data.done += 1;
        }
      }
      return;
    });

    team.sub.map((subId) => {
      const subInfo = tUsers.find((item) => item._id === subId);
      // console.log({ subInfo });
      if (subInfo.survey_token.length === 0) {
        subInfo.status = false;
      } else {
        let seasonTokenInfo = subInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === team.survey_season_id &&
            tokenInfo.relation === 4 &&
            tokenInfo.hero_id === team.user_id
        );
        data.cnt += 1;
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          data.done += 1;
        }
      }
      return;
    });
    // console.log(data);
    return data;
  };

  const joinSurveyHandler = async (tokenInfo, e) => {
    e.preventDefault();
    let sendData = {};
    try {
      // const res = await Axios.get(`api/surveyToken/t/${tokenId}`);
      // let tokenInfo = res.data.tokenInfo[0];
      // console.log(tokenInfo._id);
      // window.location.href = `/takesurvey/${tokenInfo}`;
      // console.log(tokenInfo);

      //임시적 조치, 기존 서베이가 수정 완료되면 같은곧으로포워드
      // if (tokenInfo.survey_code === '10010') {
      // -----------------------------------------------------------------------
      //人事評価力診断
      //10010はこちら
      // props.history.push(`/takesurvey/${tokenInfo._id}`);
      // } else {
      let steps = [];
      const [res, res2] = await Promise.all([
        await Axios.get(`/api/surveyToken/t/${tokenInfo._id}`),
        await Axios.get(`/api/question/${tokenInfo.survey_code}`),
      ]);
      // console.log(tokenInfo.survey_code);
      // console.log({ res2 });
      // const res = await Axios.get(`/api/surveyToken/t/${tokenInfo._id}`);
      // const res2 = await Axios.get(`/api/question/${tokenInfo.survey_code}`);

      // const res = await Axios.get(`/api/surveyToken/t/${tokenInfo._id}`);
      // const res2 = await Axios.get(
      //   `/api/question/${tokenInfo.survey_code}`
      // );
      if (res.data.success && res2.data.success) {
        const { tokenInfo } = res.data;
        const questionInfo = res2.data.question;
        // setTokenInfo(tokenInfo);
        //question_set_id：あり→可変問題構成
        //question_set_id：なし→固定問題構成
        if (tokenInfo.question_set_id) {
          // -----------------------------------------------------------------------
          //可変問題構成方式
          //20110はこちら

          const res3 = await Axios.get(
            `/api/questionSet/${tokenInfo.question_set_id}`
          );
          const { questionSet } = res3.data;
          // console.log({ questionSet });
          let qi = [];
          questionSet.question_id.forEach((qId, index) => {
            let q = questionInfo.find((item) => item._id === qId);
            q.no = index + 1;
            if (tokenInfo.survey_code === '20110') {
              q.section = '10';
              q.reqOrigin = q.required;
              // q.section = ((parseInt(index / 10) + 1) * 10).toString();
            }
            qi.push(q);
          });
          // console.log({ qi });
          sendData.questionInfo = qi;
          sendData.questionSet = questionSet;
        } else {
          // -----------------------------------------------------------------------
          //固定問題構成方式
          //30010はこちら

          // console.log({ res2 });

          // setQuestionInfo(questionInfo);
          // sendData.questionInfo = questionInfo;
          sendData.questionInfo = questionInfo;
          // console.log({ questionInfo });
        }
        //Section情報のみ数字で取り出してSortをかける
        const secNum = [
          ...new Map(
            await sendData.questionInfo.map((info) => [
              info.section,
              Number(info.section),
            ])
          ).values(),
        ].sort((first, second) => first - second);
        // console.log({ secNum });

        // let aaa = questionInfo.filter(function (question) {
        //   return question.section === '10';
        // });
        // console.log({ aaa });
        // secNum.forEach((secNum) => {
        for (let i = 0; i < secNum.length; i++) {
          const element = secNum[i];
          steps.push({
            section: element.toString(),
            questionInfo: sendData.questionInfo.filter(function (question) {
              return question.section === element.toString();
            }),
          });
        }
      } else {
        throw new Error('サーベイトークン情報取得に失敗しました。');
      }
      // props.history.push(`/newtakesurvey/${tokenInfo._id}`);
      sendData.tokenInfo = tokenInfo;
      sendData.stepArr = steps;
      sendData.seasonInfo = selSeasonInfo;
      // console.log({ sendData });
      // console.log({ steps });
      if (tokenInfo.survey_code === '90101') {
        if (ymd(tokenInfo.updatedAt) > '2025/02/01') {
          //25年3月1日以降なら新フォーマット
          props.history.push({
            pathname: '/course90105',
            state: sendData,
          });
        } else {
          props.history.push({
            pathname: '/course90101',
            state: sendData,
          });
        }
      } else if (tokenInfo.survey_code === '90301') {
        props.history.push({
          pathname: '/course90301',
          state: sendData,
        });
      } else if (tokenInfo.survey_code === '90501') {
        props.history.push({
          pathname: '/course90501',
          state: sendData,
        });
      } else if (tokenInfo.survey_code === '90502') {
        props.history.push({
          pathname: '/course90502',
          state: sendData,
        });
      } else {
        props.history.push({
          pathname: '/newtakesurvey',
          state: sendData,
        });
      }
    } catch (error) {
      alert('サーベイ参加に失敗しました。');
      console.log(error);
    }
  };

  // const surveyDeleteHandler = async (tokenId, e) => {
  //   e.preventDefault();
  //   try {
  //   } catch (error) {
  //     alert('サーベイ削除に失敗しました。');
  //     console.log(error);
  //   }
  // };

  // const viewSurveyResultHandler = async (tokenInfo, e) => {
  //   e.preventDefault();
  //   try {
  //     // console.log({ tokenInfo });

  //     let url = '';
  //     if (user.userData.groupCode) {
  //       url = `${config.S3_URL}/${config.S3_ENV}/user/${user.userData.groupCode}/${tokenInfo.user}/rcep_${tokenInfo._id}.pdf`;
  //     } else {
  //       url = `${config.S3_URL}/${config.S3_ENV}/user/${tokenInfo.user}/rcep_${tokenInfo._id}.pdf`;
  //     }
  //     window.open(url, '_blank');
  //   } catch (error) {
  //     alert('サーベイ結果確認ができません。');
  //     console.log(error);
  //   }
  // };

  // const view360ResultHandler = async (tokenI) => {
  //   try {
  //     // console.log({ tokenI });
  //     const res = await Axios.post('/api/dbModel100/makeReport40010', tokenI);
  //     return res;
  //   } catch (error) {
  //     alert('サーベイ結果確認ができません。');
  //     console.log(error);
  //   }
  // };

  const showConfirm = async (tokenI, type) => {
    // 簡易ログイン（メール未確認）セッションでは結果をダウンロードできない
    // （不要な PDF 生成・S3 アップロードを防ぐため、確認ダイアログを出す前にブロックする）
    if (isTrialQuickSession(user)) {
      blockResultForQuickSession({ dispatch, email: user.userData.email });
      return;
    }
    confirm({
      title: 'サーベイ結果を生成しますか？',
      content:
        'サーベイ結果を生成し別TabでPDF表示します。このままお待ちください。',
      async onOk() {
        setIsModalVisible(true);
        // return new Promise((resolve, reject) => {
        //   setTimeout(Math.random() > 0 ? resolve : reject, 3000);
        //   ansSendHandler();
        // }).catch(() => console.log('サーベイ結果提出でエラーが発生しました。'));
        // console.log({ tokenI });
        // console.log({ selSeasonInfo });
        tokenI.type = type; //1:個人用、2:共有用, 3:比較表, 30010:E3-Survey, 10010, 90101, 50010, 50020,　50030, 50101, 60010, 90601
        tokenI.group_name = groupInfo.group_name;
        tokenI.company = groupInfo.group_name;
        // tokenI.training_start_date = selSeasonInfo.training_start_date;
        // tokenI.training_end_date = selSeasonInfo.training_end_date;
        // tokenI.survey_start_date = selSeasonInfo.survey_start_date;
        // tokenI.survey_end_date = selSeasonInfo.survey_end_date;
        // 氏名が未設定の場合に 'undefined undefined' とならないよう防御する
        tokenI.user_name = [user.userData.lastname, user.userData.name]
          .filter(Boolean)
          .join(' ');
        tokenI.emp_no = user.userData.empNo;
        let dep = '';
        if (user.userData.department) dep = user.userData.department;
        if (user.userData.department2)
          dep = dep + ' ' + user.userData.department2;
        if (user.userData.department3)
          dep = dep + ' ' + user.userData.department3;
        if (user.userData.department4)
          dep = dep + ' ' + user.userData.department4;
        if (user.userData.department5)
          dep = dep + ' ' + user.userData.department5;
        tokenI.department = dep;
        // console.log({ tokenI });
        // console.log(user.userData);
        let result = {};
        // console.log({ type });
        if (type === 30010) {
          result = await Axios.post(
            '/api/dbModel100/makeReport30010Personal',
            tokenI
          );
        } else if (type === 1 || type === 2 || type === 3) {
          // tokenI.type_360 = selSeasonInfo.question_set[0].type_360;
          // console.log(tokenI);
          result = await Axios.post('/api/dbModel100/makeReport40010', tokenI);
        } else if (type == 10010 || type == 90101) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport', tokenI);
          // result.data.success = false;
        } else if (type == 50010 || type == 90501) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50010', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50020 || type == 90502) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50020', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50030 || type == 90503) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50030', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50040) {
          //ソーシャルスタイル診断（コース版90504は未実装）
          result = await Axios.post('/api/dbModel100/makeReport50040', tokenI);
        } else if (type == 60010 || type == 90601) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport60010', tokenI);
          // result.data.success = false;
        } else if (type == 60020) {
          // console.log(selSeasonInfo);
          // tokenI.type_360 = tokenI.type_360;
          result = await Axios.post('/api/dbModel100/makeReport40010', tokenI);
          // result.data.success = false;
        }
        if (result.data.success) {
          // message.success('結果生成が完了しました。マイ・サーベイに戻ります。');
          // props.history.push('/mysurvey');
          message.success({
            content: 'ファイル生成完了！',
            key: 'makecsv',
            duration: 2,
          });
          setIsModalVisible(false);
          openReport(result.data.tokenId);
        } else {
          setIsModalVisible(false);
          console.log('結果生成で問題が発生しました。');
          message.error('結果生成で問題が発生しました。');
        }
      },
      async onCancel() {},
    });
  };

  // ▼ テーブル強化 PJ Ph.2: <Column> 子要素 → columns 配列へ変換。
  // データ列はソート（タイトルは省略 + ツールチップ）、アクション 2 列は既存ボタンを維持。
  // 列幅ドラッグ・初期フィット（コンテナ幅充満）・横スクロールは useResizableColumns が配線。
  const rawColumns = [
    ellipsisColumn({
      title: 'タイトル',
      dataIndex: 'surveyName',
      key: 'surveyName',
      width: 280,
      sorter: textSorter('surveyName'),
    }),
    {
      title: '公開日',
      dataIndex: 'survey_start_date',
      key: 'survey_start_date',
      width: 120,
      sorter: dateSorter('survey_start_date'),
      render: (text, record) => {
        if (!record.survey_start_date) return '-';
        return formatSurveyDateOnly(record.survey_start_date);
      },
    },
    {
      title: '実施期限',
      dataIndex: 'survey_end_date',
      key: 'survey_end_date',
      width: 120,
      sorter: dateSorter('survey_end_date'),
      render: (text, record) => {
        // トライアルユーザーはトークンの有効期限（token_expire, JST）を表示。
        // シーズンの 2100 年（survey_end_date）ではなくトークン個別の期限を出す。
        if (isTrialUser) {
          return record.token_expire
            ? formatJstDateOnly(record.token_expire)
            : '-';
        }
        if (!record.survey_end_date) return '-';
        return formatSurveyDateOnly(record.survey_end_date);
      },
    },
    {
      title: 'ステータス',
      dataIndex: 'surveyStatusName',
      key: 'surveyStatusName',
      width: 130,
      // ソートはステータスコード（survey_status）の数値順
      sorter: (a, b) => (a.survey_status ?? 0) - (b.survey_status ?? 0),
      render: (text, record) => {
        // デザインシステム Ph.6 後続-4: 共用 StatusBadge（tone ベース pill）。
        return (
          <StatusBadge tone={SURVEY_STATUS_TONE[record.survey_status]}>
            {text}
          </StatusBadge>
        );
      },
    },
    {
      title: 'アクション',
      key: 'action',
      width: 120,
      render: (text, record) => (
        <span>
          {record.survey_code === '90101' ||
          record.survey_code === '90301' ||
          record.survey_code === '90502' ||
          record.survey_code === '90501' ? (
            <Button
              type={'primary'}
              size="small"
              onClick={(e) => joinSurveyHandler(record, e)}
              disabled={false}
            >
              回答開始
            </Button>
          ) : (
            <Button
              type={'primary'}
              size="small"
              onClick={(e) => joinSurveyHandler(record, e)}
              disabled={
                record.survey_status === 0 || record.survey_status === 1
                  ? false
                  : true
              }
            >
              回答開始
            </Button>
          )}
        </span>
      ),
    },
    {
      title: '結果・詳細',
      key: 'detail',
      width: 300,
      render: (text, record) => (
        <span>
          {record.survey_code === '10010' &&
          record.output_360_type !== 0 ? (
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, record.survey_code)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.survey_status === 5) ||
                    (record.output_360_type === 2 &&
                      record.survey_status === 5 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '50010' &&
            record.output_360_type !== 0 ? (
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, record.survey_code)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.survey_status === 5) ||
                    (record.output_360_type === 2 &&
                      record.survey_status === 5 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '90101' ||
            record.survey_code === '60010' ||
            record.survey_code === '90601' ||
            record.survey_code === '90502' ||
            record.survey_code === '90501' ? (
            <Button
              type={'default'}
              className="ds-btn-secondary"
              size="small"
              onClick={(e) => showConfirm(record, record.survey_code)}
              disabled={record.survey_status === 5 ? false : true}
            >
              結果確認 &nbsp;{' '}
              <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
            </Button>
          ) : record.survey_code === '40010' &&
            record.relation === 1 &&
            record.output_360_type !== 0 &&
            record.type_360 !== '3x3x5' &&
            record.type_360 !== 'gates' &&
            record.type_360 !== 'initiative' &&
            record.type_360 !== 'eleader' ? ( //360診断＋本人の場合+公開設定が非公開じゃない
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 1)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.allStatus === 1) ||
                    (record.output_360_type === 2 &&
                      record.allStatus === 1 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                個人用 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 2)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.allStatus === 1) ||
                    (record.output_360_type === 2 &&
                      record.allStatus === 1 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                共有用 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 3)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.allStatus === 1 &&
                      record.lastSeason) ||
                    (record.output_360_type === 2 &&
                      record.allStatus === 1 &&
                      isPassed(record.output_360_date) &&
                      record.lastSeason)
                  )
                }
              >
                比較表 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '40010' &&
            record.relation === 1 &&
            record.output_360_type !== 0 &&
            (record.type_360 === '3x3x5' ||
              record.type_360 === 'gates' ||
              record.type_360 === 'initiative' ||
              record.type_360 === 'eleader') ? ( //360診断＋本人の場合+公開設定が非公開じゃない
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 1)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.allStatus === 1) ||
                    (record.output_360_type === 2 &&
                      record.allStatus === 1 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '30010' &&
            record.e3_option &&
            record.output_360_type !== 0 ? ( //E3-Survey単体 + パーソナル診断Optionあり + 公開設定が非公開じゃない
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 30010)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.survey_status === 5) ||
                    (record.output_360_type === 2 &&
                      record.survey_status === 5 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '90301' &&
            record.e3_option ? ( //E3-Surveyコース + パーソナル診断Optionあり
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 30010)}
                disabled={record.survey_status === 5 ? false : true}
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '50020' &&
            record.output_360_type !== 0 ? (
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 50020)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.survey_status === 5) ||
                    (record.output_360_type === 2 &&
                      record.survey_status === 5 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '50030' &&
            record.output_360_type !== 0 ? (
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 50030)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.survey_status === 5) ||
                    (record.output_360_type === 2 &&
                      record.survey_status === 5 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '50040' &&
            record.output_360_type !== 0 ? (
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 50040)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.survey_status === 5) ||
                    (record.output_360_type === 2 &&
                      record.survey_status === 5 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : record.survey_code === '60020' &&
            record.relation === 1 &&
            record.output_360_type !== 0 ? ( //360診断＋本人の場合+公開設定が非公開じゃない
            <Space>
              <Button
                type={'default'}
                className="ds-btn-secondary"
                size="small"
                onClick={(e) => showConfirm(record, 60020)}
                disabled={
                  !(
                    (record.output_360_type === 1 &&
                      record.allStatus === 1) ||
                    (record.output_360_type === 2 &&
                      record.allStatus === 1 &&
                      isPassed(record.output_360_date))
                  )
                }
              >
                結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : (
            <Button
              type={'default'}
              className="ds-btn-secondary"
              size="small"
              disabled={true}
            >
              個別結果はありません
            </Button>
          )}
        </span>
      ),
    },
  ];

  // 列幅ドラッグ + 初期フィット + 横スクロールの配線
  const { columns, components, scroll, wrapRef } = useResizableColumns(rawColumns);

  // return <div>User Management Page2</div>;
  return (
    <Fragment>
      {/* テーブル（調査一覧）ページのため fluid（全幅）。
          一覧系の幅挙動を他の管理ページと統一（デザインシステム「大量テーブル」例外）。
          2 次トラック S3 item 4.1: ヘッダー/ナビとテーブルの間が詰まっていたため
          上部に余白（--space-6 = 24px）を追加。 */}
      <PageContainer fluid style={{ paddingTop: 'var(--space-6)' }}>
        {/* item 4.2〜4.4: 列タイトル（ヘッダー）の cream 塗り + 上下線は
            2 次トラック S3-b で全テーブルへグローバル昇格（index.js headerBg + index.css 上下線）。
            個別 className は不要になったため撤去。 */}
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            dataSource={mySurvey}
            size="middle"
            rowKey="_id"
          />
        </div>
      </PageContainer>
      <Modal
        title="サーベイ結果ファイル生成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
}

export default MySurveyPage;
